import { AUDITDATA, AUDITDATAFETCH } from './actionType'
import axios from 'axios'
import tapConfig from '../../tapConfig'

export function auditData(blossomID, page, pageSize) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(auditDataFetching(true))
        axios
          .get(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/audit_logs?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID) +
              '&page=' +
              encodeURIComponent(page) +
              '&per_page=' +
              encodeURIComponent(pageSize),
          )
          .then(function (response) {
            dispatch(auditDataResponseData(response))
            dispatch(auditDataFetching(false))
          })
          .catch(function () {
            dispatch(auditDataFetching(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(auditDataFetching(false))
      })
  }
}

function auditDataResponseData(response) {
  return {
    type: AUDITDATA,
    data: response.data,
  }
}

function auditDataFetching(status) {
  return {
    type: AUDITDATAFETCH,
    auditDataFetching: status,
  }
}
